import * as React from "react";
import {ChecklistState} from "../api/dtos/dtos";
import {checklistStateToDto} from "./dtos";


interface Props {
  state: ChecklistState;
  style?: React.CSSProperties;
}

class ChecklistStateLabel extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {state, style} = this.props;

    const dto = checklistStateToDto[state];

    return (
      <>
        {state !== ChecklistState.NOT_REQUIRED &&
            <div style={{...style, color: dto.color, display: "inline"}}>{dto.text}</div>
        }
      </>
    );
  }
}

export default ChecklistStateLabel;


// WEBPACK FOOTER //
// ./src/checklist/ChecklistStateLabel.tsx